import * as Sentry from "@sentry/react";
import dayjs from "dayjs";

const sentry4Action = (action, userInfo) => {
  //   if (import.meta.env.MODE === "development") return;
  //   return Sentry.captureException(
  //     new Error(`${action}-${dayjs(Date.now()).format("YYYY-MM-DD HH:mm:ss")}`),
  //     {
  //       level: "info",
  //       user: {
  //         url: location.href,
  //         time: dayjs(Date.now()).format("YYYY-MM-DD HH:mm:ss"),
  //         accountInfo: JSON.parse(localStorage.getItem("user")),
  //         ...userInfo,
  //       },
  //     }
  //   );
  Sentry.captureMessage(action, {
    level: "info",
    user: {
      ...userInfo,
    },
  });
};

export default sentry4Action;
